import { useDispatch } from "react-redux";
import { onDeleteLike, onDeleteTrashUser } from "../../../match/presentation/store/MatchThunk";
import { deleteMyNotificationAction, deleteNewMatch } from "../../../match/presentation/store/MatchSlice";
import { AppDispatch } from "../../../../core/store/store";
import { Likes } from "../../../match/domain/entities/userMatch";
import { deleteChat, deleteSelectedChat } from "../../../chat/presentation/store/ChatSlice";
import InfoNotificationAdmin from "../../domain/entities/InfoNotificationAdmin";
import useMatch from "../../../match/presentation/hook/useMatch";
import { onDeleteNotification } from "../store/NotificationThunk";

export const useHandleDeleteNotification = () => {
	const dispatch: AppDispatch = useDispatch();
	const { handleLike, handleUpdateMatchesSearch } = useMatch();

	return (category: string, notification: Likes | InfoNotificationAdmin) => {
		switch (category) {
			case "like":
				handleLike(notification.user_id, "dislike");
				dispatch(deleteMyNotificationAction({ type: "like", user_id: (notification as Likes).user_id }));
				handleUpdateMatchesSearch(notification.user_id);
				break;
			case "match":
				dispatch(deleteNewMatch((notification as Likes).user_id));
				dispatch(onDeleteTrashUser((notification as Likes).user_id));
				dispatch(deleteChat({ chat_id: (notification as Likes).match_id }));
				dispatch(deleteSelectedChat());
				dispatch(deleteMyNotificationAction({ type: "match", user_id: (notification as Likes).user_id }));
				break;
			case "myLikes":
				dispatch(onDeleteLike((notification as Likes).match_id));
				dispatch(deleteMyNotificationAction({ type: "myLikes", user_id: (notification as Likes).user_id }));
				break;
			case "alert":
				const alertId =
					(notification as InfoNotificationAdmin).id ||
					(notification as InfoNotificationAdmin).notification_id;
				if (!alertId) break;
				dispatch(deleteMyNotificationAction({ type: "alert", user_id: alertId }));
				dispatch(onDeleteNotification({notification_id: alertId }));
				break;
		}
	};
};
